import { PostProperties } from "../types";
import image from "../img/lostGemFrequency7.jpg";

const post: PostProperties = {
  id: 38,
  title:
    "Frequency 7 (Ben Sims & Surgeon) - Club Museum, Unit, Tokyo (07.05.2010)",
  content: `Surgeon and Ben Sims. Together they are known as Frequency 7. This is a one-hour excerpt of a seven-hour set in the legendary club Unit in Tokyo. According, to an interview with Surgeon, the duo decided to play for 7 hours, on the 7th of May, as Frequency 7. Although this short excerpt won't be able to do the whole night justice, it still manages to showcase the lighter side of the duo and their ability to tell a story.`,
  image,
  buttonText: "Listen Here",
  buttonUrl:
    "https://soundcloud.com/shubinproject/frequency-7-ben-sims-surgeon-club-museum-unit-tokyo-07052010",
  category: "Lost Gem",
  translationsBg: {
    content: `Surgeon и Бен Симс. Заедно те са известни като Frequency 7. Това е едночасов откъс от седемчасов сет в легендарния клуб Unit в Токио. Според интервю със Surgeon, дуото е решило да свири 7 часа на 7 май като Frequency 7. Въпреки че този кратък откъс няма да може да предаде справедливостта на цялата вечер, той все пак успява да покаже по-светлата страна на дуото и способността им да разказват истории.`,
  },
};

export default post;
